import { Button, Confirm, Label, Table } from 'semantic-ui-react'
import LinkToPlayLogVideo from '../../components/LinkToPlayLogVideo'
import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import { dateTimeFormat } from '../../lib/config'
import moment from 'moment'
import { withState } from 'recompose'

// https://stackoverflow.com/a/1026087
function ucfirst(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

function ReportRaw({
	logs,
	metrics,
	myTags,
	exercise,
	removeLog,
	confirmingDeleteLog,
	setConfirmingDeleteLog
}) {
	const confirmingContent = confirmingDeleteLog
		? `Are you sure you want to delete the log on ${moment
				.unix(_.find(logs, ['__id', confirmingDeleteLog]).when / 1000)
				.format(dateTimeFormat)}`
		: false
	return (
		<div>
			<Table celled fixed unstackable>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>When</Table.HeaderCell>
						{_.map(metrics, (value, metric) =>
							<Table.HeaderCell key={metric}>{metric}</Table.HeaderCell>
						)}
						{myTags.length
							? <Table.HeaderCell>
									Variations
								</Table.HeaderCell>
							: false}
						<Table.HeaderCell>&nbsp;</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Confirm
					open={Boolean(confirmingDeleteLog)}
					onCancel={() => setConfirmingDeleteLog()}
					content={confirmingContent}
					onConfirm={() => {
						removeLog(confirmingDeleteLog)
						setConfirmingDeleteLog()
					}}
				/>
				<Table.Body>
					{_.map(logs, log =>
						<Table.Row key={log.__id}>
							<Table.Cell>
								{moment.unix(log.when / 1000).format(dateTimeFormat)}
							</Table.Cell>
							{_.map(metrics, (value, metric) =>
								<Table.Cell key={metric}>{_.get(log, `metrics.${metric}`)}</Table.Cell>
							)}
							{myTags.length
								? <Table.Cell>
										{_.map(log.tags, tag => <Label key={tag}>{ucfirst(tag)}</Label>)}
									</Table.Cell>
								: false}
							<Table.Cell>
								<Button
									icon="trash"
									secondary
									size="huge"
									onClick={() => {
										setConfirmingDeleteLog(log.__id)
									}}
								/>
								{log.cloudinaryVideoPublicId
									? <LinkToPlayLogVideo
											logId={log.__id}
											backTo={`/do/${log.exercise}`}
											backTitle={'Back to exercise'}
										/>
									: false}
							</Table.Cell>
						</Table.Row>
					)}
				</Table.Body>
			</Table>
		</div>
	)
}
ReportRaw.propTypes = {
	logs: PropTypes.arrayOf(PropTypes.object),
	metrics: PropTypes.object.isRequired,
	myTags: PropTypes.arrayOf(PropTypes.string).isRequired,
	removeLog: PropTypes.func.isRequired,
	exercise: PropTypes.shape({ title: PropTypes.string }),
	confirmingDeleteLog: PropTypes.string,
	setConfirmingDeleteLog: PropTypes.func.isRequired
}
const Report = withState('confirmingDeleteLog', 'setConfirmingDeleteLog')(ReportRaw)

export default Report



// WEBPACK FOOTER //
// ./src/pages/Do/Report.js